import React, { useState } from 'react';
import '../scss/components/subscribe.scss'
import axios from 'axios';
import * as Yup from "yup";
import { Formik } from "formik";

const PORTAL_ID = '7284441';
const FORM_ID = 'e75299de-0714-40ec-93eb-ca7b5a1ad09c';

const Subscribe = () => {

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Must be a valid email")
      .required("Required")
  })

  const successMessage = () => {
    return(
      <section className="sectionSpacing pt-0">
        <div className="mb-0">
          <div class="container" id="confirmation--message">
            <div class="row">
              <div class="col-12 my-auto text-center">
                <img className="mt-2" src="/home/successfulFormSubmission.svg" alt="The ChartHop logo"></img>
                <p class="main--text--confirmation"> Great!
                <br/> We’ll email you shortly.</p>
              </div>
             </div>
          </div>
        </div>
      </section>
    )
  }

  const errorMessage = () => {
    return(
      <div className="error-submitting">
        Sorry, but we had an unexpected problem submitting your request.
        Try again later, or send a note to{" "}
        <a href="mailto:hello@charthop.com">hello@charthop.com</a>.
      </div>
    )
  }

  const _handleSubmit = async (values) => {
    axios
      .request({
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        url: `https://api.hsforms.com/submissions/v3/integration/submit/${PORTAL_ID}/${FORM_ID}`,
        data: JSON.stringify({
          fields: [
            {
              name: 'email',
              value: values.email,
            },
          ],
        }),
      })
      .then(
        res => {
          setSubmitted(true);
          setError(false);
        },
        err => {
          setSubmitted(true);
          setError(true);
        }
      );
  }
  if(submitted && !error){
    return(
      successMessage()
    )
  }
  return (
    <section className="sectionSpacing pt-0">
      <div className="mb-0">
          <div class="container" id="subscribe--box">
          <div class="row d-flex flex-row justify-content-between subscribe--row">
            <div class="col-md-6 col-sm-12 my-auto">
              <p class="subscribe--box--main--text">Get exclusive access to our latest updates</p>
              <p class="subscribe--box--secondaty--text">Subscribe to our newsletter and stay updated!</p>
            </div>
            <div class="col-md-6 col-sm-12 align-self-end my-auto">
              <div>
                <Formik
                  initialValues={{ email: "" }}
                  validationSchema={validationSchema}
                  onSubmit={_handleSubmit}
                  render={form => (
                    <form
                      id="subscribe-form"
                      data-portal-id={PORTAL_ID}
                      data-form-id={FORM_ID}
                      onSubmit={form.handleSubmit}
                      class="subscribe--form d-flex flex-row justify-content-end"
                    >
                      <div className="input-container">
                       <input
                        id="emailshort"
                        name="email"
                        type="text"
                        className="subscribe--input--field"
                        value={form.values.email}
                        onChange={form.handleChange}
                        placeholder="Email"
                      />
                      {form.touched.email && form.errors.email && (
                        <div className="error-message">{form.errors.email}</div>
                      )}
                      </div>
                      <button type="submit" class="subscribe--button button primary align-middle">SUBSCRIBE</button>
                    </form>
                  )}
                />
                <div class="subscribe--disclaimer">
                  <p class="subscribe--disclaimer--text">By submitting your info, you agree to opt-in to emails from ChartHop.</p>
                </div>
              </div>
            </div>
          </div>
          
          {error ? errorMessage() : ""}
        </div>
      </div>
    </section>
  )
}

export default Subscribe;